export default __webpack_public_path__ + "static/media/displayMd.ff54af95.png";